export { getLink, getLinkFromLocalStorage, storeCurrentLocation } from './utils/utils';
export { GO_BACK_PREFIX } from './core/constants';
